<div class="cell-phone-validation-wrapper-container"
  fxLayout="column">
  <div class="cell-phone-validation-container"
    fxFlex="100"
    fxLayout="column">
    <app-login-header fxLayoutAlign.xs="center stretch"></app-login-header>
    <div class="cell-phone-validation-body-container"
      ngClass.lt-sm="small-cell-phone-validation-body-container"
      fxFlex="grow"
      fxLayout="column"
      fxLayoutAlign="start center"
      fxLayoutGap="2rem">
      <div class="font-size-x-large-container text-align-center bold-container">
        Finish creating your account
      </div>
      <div class="font-size-medium-container text-align-center grey-text">
        Please verify your phone number with the code that was sent to you via text
      </div>
      <form ngClass.lt-sm="full-width-container"
        fxLayout="column"
        fxLayoutGap="1rem"
        [formGroup]="cellphoneValidationFormGroup">
        <mat-form-field appearance="outline"
          class="full-width-container">
          <input matInput
            appNumbersOnly
            autocomplete="one-time-code"
            autofocus
            formControlName="cellphoneValidationCodeControl"
            inputmode="numeric"
            maxlength="6"
            placeholder="Cell Phone Confirmation Code"
            required
            tabindex="1"
            type="text"
            (keyup.enter)="submit()">
            <mat-hint>Confirmation code</mat-hint>
            @if (cellphoneConfirmationCodeRequired()) {
              <mat-error>
                Cell phone confirmation code is <strong>required</strong>.
              </mat-error>
            }
            @if (cellphoneConfirmationCodeMatchRequired()) {
              <mat-error>
                SMS Verification code does not match.
              </mat-error>
            }
            @if (subscriptionInviteKeyUsed()) {
              <mat-error>
                The link to create an account here has already been used.
              </mat-error>
            }
            @if (unableToCommunicate()) {
              <mat-error>
                An error has occurred, Please try again later.
              </mat-error>
            }
          </mat-form-field>
          <app-loading-button class="button-container"
            ngClass.gt-xs="center-align"
            buttonText="Submit"
            [isDisabled]="cellphoneValidationFormGroup.pending"
            [isFullWidth]="true"
            [request$]="verifyPhoneCode$"
          (clickEvent)="submit()"></app-loading-button>
          <mat-divider class="full-width-container"></mat-divider>
          <div fxLayout="row"
            fxLayout.lt-sm="column"
            fxLayoutGap="1em">
            <app-loading-button class="button-container"
              matButtonType="matStroked"
              buttonText="Request New Code"
              [isDisabled]="cellphoneValidationFormGroup.pending"
              [isFullWidth]="true"
              [request$]="sendPhoneCode$"
            (clickEvent)="sendNewPhoneCode()"></app-loading-button>
            <button mat-stroked-button
              class="custom-round-button button-container"
              color="primary"
            (click)="updatePhoneNumber()">Update Phone Number</button>
          </div>
        </form>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
